export const viewportHeightWithoutMiniHeader = () => ("lg:h-[calc(100vh-40px-4rem)]");